import React, { useState, useRef, useContext } from "react";
import headeLogo from "../../../../assets/images/shersoftnavLogo.png";
import close from "../../../../assets/images/CreateCompanyImages/Wrong (1).webp";
import ComboBox from "../../../ComboBoxes/ComboBox";
import crtCmp from "../../../../assets/images/CreateCompanyImages/CreateCmp.webp";
import exit from "../../../../assets/images/CreateCompanyImages/Cdbexit.webp";
import { AuthContext } from "../../../../context/AuthContext";
import { useDbContext } from "../../../../context/DbContext";
import axios from "axios";

function PrinterSettings( zIndex) {
  return (
    <div className=" w-full h-[400px]  flex  box-border" style={{ zIndex }}>
     

    </div>
  );
}

export default PrinterSettings;
